var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (this.show())?_c('CBadge',{attrs:{"color":this.color(),"shape":"pill"}},[_vm._v(_vm._s(this.text()))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }